import React, { Component } from 'react'
import { CSVLink } from 'react-csv'
import './Export.scss'

class ExportCsv extends Component {
  render() {
    return (
      <CSVLink {...this.props} className="export-csv">
        <span className="fas fa-file-download download-icon " />
      </CSVLink>
    )
  }
}

export default ExportCsv
